module.exports = __webpack_public_path__ + "img/give-awards.47beae86.png";